import React from 'react';
import Icon from '../components/common/Icon/Icon';
import { useAppSelector } from '../redux/hooks';

const WarningIcon: React.FC = () => {
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);

  return (
    <Icon
      name="warning_icon_square"
      size={14}
      color={currentTheme === 'light' ? '#D91734' : '#F16A81'}
    />
  );
};

export default WarningIcon;
